import { Injectable } from '@angular/core';
import { affiliateCode } from '../../shared/constants/constants';
import { SERVER } from '../../shared/enum/server.enum';
import { API } from '../../shared/models/api.model';
import {
  accountId, addressType,
  aliasCode, cartId, entryNumber,
  entryPk, orderCode,
  orderId, parentCartId,
  partyId, postalCode, productCode,
  shopPk, shopUid, userId, voucherId
} from './../../shared/constants/end-point-constants';

@Injectable({
  providedIn: 'root'
})
export class ApiConfigService {
  apiConfig: { [key: string]: API };
  masheryV1Path = '/rest/registration/v1/';
  masheryV3Path = '/rest/mdms/v3/';
  constructor() {
    this.apiConfig = {
      productSearchAPI: {
        path: `products/search`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      addProductToShopAPI: {
        path: `accounts/${accountId}/itemList/addProductsToItemList`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      removeProductFromListAPI: {
        path: `accounts/${accountId}/itemList/entries`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      updateProductInListAPI: {
        path: `accounts/${accountId}/itemList/entries/${entryPk}`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      getShopInfoAPI: {
        path: `getShopDetails`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      getShopSponsorAPI: {
        path: `getShopSponsor`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      updateShopInfoAPI: {
        path: `accounts/${accountId}/shop/${shopPk}/updateShopDetails`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      getShopListAPI: {
        path: `getItemListsForShop`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      getColorListAPI: {
        path: `shop/getItemListColor`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      cartDetailsByCartIdAPI: {
        path: `users/${userId}/carts/${cartId}`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      createNewShopListAPI: {
        path: `accounts/${accountId}/createNewList`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      validateShopNameAPI: {
        path: `accounts/${accountId}/validateShopName`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      getShoplistDetailByIdAPI: {
        path: `itemList/getItemListDetails`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      getShoplistPromotionAPI: {
        path: `itemList/getPromotionsForProducts`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      updateEntryInCartAPI: {
        path: `users/${userId}/carts/${cartId}/entries/${entryNumber}`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: false
      },
      addBundleProductAPI: {
        path: `accounts/${accountId}/itemList/addBundle`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      updateShoplistDetailAPI: {
        path: `accounts/${accountId}/itemList/updateItemListDetails`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      applyCouponAPI: {
        path: `users/${userId}/carts/${cartId}/vouchers`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: false
      },
      removeCouponAPI: {
        path: `users/${userId}/carts/${cartId}/vouchers/${voucherId}?fields=FULL`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: false
      },
      getTinyUrlAPI: {
        path: `share/short/url/save`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      decodeTinyUrlAPI: {
        path: `share/short/url/fetch`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      createCartAPI: {
        path: `users/${userId}/carts`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      addProductToCartAPI: {
        path: `users/${userId}/carts/${cartId}/entries`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: false
      },
      getProductDetailsAPI: {
        path: `products/${productCode}`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      getProductDetailsFromAliasCodeAPI: {
        path: `productDetail/${aliasCode}`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      getOrderDetailsAPI: {
        path: `orders/${orderCode}`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      getGroupOrderDetailsAPI: {
        path: `users/${userId}/orders/${orderId}/grouporder`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      validateCaptchaAPI: {
        path: this.masheryV1Path + `validate/captcha`,
        pointTo: SERVER.Mashery,
        loggingRequired: false,
        isAuthRequired: true
      },
      getOccAuthTokenAPI: {
        path: `authorizationserver/oauth/token`,
        pointTo: SERVER.Public,
        loggingRequired: false,
        isAuthRequired: false
      },
      getProvinceListAPI: {
        path: 'address-suggest/province',
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      getDistrictsAPI: {
        path: `address-suggest/${addressType}`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      mdmsCountryListAPI: {
        path: this.masheryV1Path + `config/affiliates/0/countries`,
        pointTo: SERVER.Mashery,
        loggingRequired: false,
        isAuthRequired: true,
        isCaptchaTokenRequired: true
      },
      getCountryListAPI: {
        path: 'countries/getCountryList',
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      validateCidAPI: {
        path: this.masheryV1Path + `validate/tax/${affiliateCode}`,
        pointTo: SERVER.Mashery,
        loggingRequired: true,
        isAuthRequired: true,
        isCaptchaTokenRequired: true
      },
      validatePidAPI: {
        path: this.masheryV1Path + `validate/personal-id/${affiliateCode}`,
        pointTo: SERVER.Mashery,
        loggingRequired: true,
        isAuthRequired: true,
        isCaptchaTokenRequired: true
      },
      validateContactsAPI: {
        path: this.masheryV1Path + `validate/contacts/${affiliateCode}`,
        pointTo: SERVER.Mashery,
        loggingRequired: true,
        isAuthRequired: true,
        isCaptchaTokenRequired: true
      },
      validateSponsorABOAPI: {
        path: this.masheryV1Path + `validate/sponsor/${affiliateCode}`,
        pointTo: SERVER.Mashery,
        loggingRequired: true,
        isAuthRequired: true,
        isCaptchaTokenRequired: true
      },
      retrieveSponsorByPostalCodeAPI: {
        path: this.masheryV1Path + `salesPlanAff/${affiliateCode}/sponsors/retrieve-by-postal-cd/${postalCode}`,
        pointTo: SERVER.Mashery,
        loggingRequired: false,
        isAuthRequired: true
      },
      createRegistrationCartAPI: {
        path: 'registration/createRegistrationCart',
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      updateCustomerAPI: {
        path: 'registration/updateCustomer',
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      updateRegistrationCartAPI: {
        path: 'registration/updateCart',
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      saveRegistrationDataAPI: {
        path: this.masheryV1Path + `full-accounts/${affiliateCode}`,
        pointTo: SERVER.Mashery,
        loggingRequired: true,
        isAuthRequired: true,
        isCaptchaTokenRequired: true
      },
      validateCartAPI: {
        path: `users/${userId}/carts/${cartId}/validate`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      freezeCartAPI: {
        path: `users/${userId}/carts/${cartId}/prepare`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      combineCartsAPI: {
        path: `users/${userId}/carts/${parentCartId}/combineCarts`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      getExtendedCartByIdAPI: {
        path: `users/${userId}/carts/${cartId}/groupcart?fields=FULL`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      getABOImageAPI: {
        path: this.masheryV3Path + `accounts/${userId}/parties/${partyId}/images`,
        pointTo: SERVER.Mashery,
        loggingRequired: false,
        isAuthRequired: true
      },
      retrieveImageByUrlAPI: {
        path: this.masheryV3Path + `accounts/${userId}/parties/${partyId}/images/retrieve-by-url`,
        pointTo: SERVER.Mashery,
        isAuthRequired: true,
        loggingRequired: false
      },
      shopFoaProductsAPI: {
        path: `search/3eProduct/products`,
        pointTo: SERVER.Hybris,
        isAuthRequired: false,
        loggingRequired: false
      },
      productRegionAvailabilityAPI: {
        path: `products/${productCode}/productRegionAvailability`,
        pointTo: SERVER.Hybris,
        isAuthRequired: false,
        loggingRequired: false
      },
      updateFoaFlagInCartAPI: {
        path: `carts/${cartId}/update/cart`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      getCouponsAPI: {
        path: `accounts/${accountId}/users/${userId}/coupons`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      assignRegistrationCartAPI: {
        path: `carts/${cartId}/assignRegistrationCart`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      getAccountAddressBookAPI: {
        path: this.masheryV3Path + `accounts/${affiliateCode}-${userId}/parties/${partyId}/addressbook`,
        pointTo: SERVER.Mashery,
        loggingRequired: false,
        isAuthRequired: true
      },
      addNewAddressAPI: {
        path: this.masheryV3Path + `accounts/${affiliateCode}-${userId}/parties/${partyId}/addressbook`,
        pointTo: SERVER.Mashery,
        loggingRequired: true,
        isAuthRequired: true
      },
      updateAddressInCartAPI: {
        path: `users/${userId}/carts/${cartId}/addresses/delivery`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      assignCartToCustomerAPI: {
        path: `accounts/${accountId}/users/${userId}/carts/${cartId}/assignCart`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      removeMultipleEntryFromCartAPI: {
        path: `users/${userId}/carts/${cartId}/entries/multi`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: false
      },
      authorizationAPI: {
        path: `authorize`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      validatePaymentRetryAPI: {
        path: `registration/validatePaymentRetry`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      deleteShoplistAPI: {
        path: `accounts/${accountId}/itemList/inactivateItemListDetails`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      getMdmsFullAccountDetailAPI: {
        path: this.masheryV3Path + `accounts/${affiliateCode}-${accountId}`,
        pointTo: SERVER.Mashery,
        loggingRequired: false,
        isAuthRequired: true
      },
      changePartyRoleAPI: {
        path: this.masheryV3Path + `full-accounts/${affiliateCode}-${accountId}/parties/changePartyRole`,
        pointTo: SERVER.Mashery,
        loggingRequired: true,
        isAuthRequired: true
      },
      upgradeAccountAPI: {
        path: `renewal/volumeRenewal/accounts/${accountId}/parties/${partyId}`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      getContractInfoAPI: {
        path: this.masheryV1Path + `config/affiliates/${affiliateCode}/contract`,
        pointTo: SERVER.Mashery,
        loggingRequired: false,
        isAuthRequired: true,
        isCaptchaTokenRequired: true
      },
      verifyIdCardOnCredenAPI: {
        path: 'registration/verify/idCard',
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      downgradeAccountAPI: {
        path: `accounts/${accountId}/users/${userId}/downgrade`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      checkAvailabilityOfShopUidAPI: {
        path: 'checkAvailabilityOfShopUid',
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      uploadDocumentAPI: {
        path: 'customer/document/upload',
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      validatePhoneNumberAPI: {
        path: this.masheryV1Path + `validate/phone/${affiliateCode}`,
        pointTo: SERVER.Mashery,
        loggingRequired: true,
        isAuthRequired: true
      },
      generateOtpAPI: {
        path: 'otp/generate/v2',
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      validateOtpAPI: {
        path: 'otp/verification/v2',
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      fetchShopProfileImageAPI: {
        path: 'getShopProfilePicture',
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: false
      },
      uploadShopProfileImageAPI: {
        path: `shop/profile-picture`,
        pointTo: SERVER.Hybris,
        loggingRequired: false,
        isAuthRequired: true
      },
      getMobHeaderClassAPI: {
        path: `json/page-mob-header-class.json`,
        pointTo: SERVER.Local,
        loggingRequired: false,
        isAuthRequired: false
      },
      updateAuxillaryProductsAPI: {
        path: `users/${userId}/carts/${cartId}/auxiliary-products`,
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      },
      validateOtpForDowngradeAPI: {
        path: 'otp/downgrade/verification',
        pointTo: SERVER.Hybris,
        loggingRequired: true,
        isAuthRequired: true
      }
    };
  }

  /**
   *
   *
   * Function to fetch the complete API configs
   *
   * for the particular API key
   *
   *
   *
   * @param key API key argument used to fetch the configuration
   * @returns API Returns the API config model
   * @memberof ApiConfigService
   */
  getAPIPath(key: string): API {
    return Object.assign({}, this.apiConfig[key]);
  }

}
